module.exports = __webpack_public_path__ + "static/media/43-8.e7238492.mp3";